import { useMemo } from 'react'
import useCustomSchedule from '../../../../../hooks/useCustomSchedule'
import { ActiveScheduleLinkIcon } from '../../../planning/Svgs'
import './ActiveTaskOverlay.scss'
import CustomToolTip from '../../../../../../CommonComponents/CustomToolTip'
import useUrlNavigation from '../../../../../hooks/useUrlNavigation'

const ActiveTaskOverlay = () => {
    const { navigate_to } = useUrlNavigation()
    const { onboardScheduleDetails } = useCustomSchedule()

    const activeSchedule = useMemo(() => {
        return (
            onboardScheduleDetails?.scheduleData?.active?.length > 0
                ? onboardScheduleDetails.scheduleData.active[0]?.scheduleName
                : 'No Active Schedule'
        );
    }, [onboardScheduleDetails?.scheduleData?.active]);

    const handleClick = () => {
        if (onboardScheduleDetails?.scheduleData?.active?.length == 0) return
        navigate_to('plan-onboard-schedule')
    }
    
    return (
        <div className='active__task__overlay'
            onClick={() => handleClick()}
        >
            <div className='active__task__overlay__header'>
                <div className='active__task__overlay__header__title'>
                    Active Schedule
                </div>
                <div className='active__task__overlay__header__icon'>
                    <ActiveScheduleLinkIcon />
                </div>
            </div>
            <div className='active__task__details'>
                <CustomToolTip
                    title={activeSchedule ?? ""}
                    placement="bottom"
                >
                    {activeSchedule ??  'No Active Schedule'}
                </CustomToolTip>
            </div>
        </div>
    )
}

export default ActiveTaskOverlay